module.exports = __webpack_public_path__ + "img/enterprise-institution-3.b81fea5f.png";